<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
};
</script>

<style>
  body {
    font-family: 'Roboto', sans-serif;
    margin: 0;
  }

  .direct {
    background-color: #111;
  }
</style>
